import React from 'react';
import { store } from '~/store';
import { Provider } from 'react-redux';

export const StoreProvider: React.FC = ({ children }) => (
  <Provider store={store}>{children}</Provider>
);
